export const getDateOnly = (input: Date) => {
    return `${input.getFullYear()}-${input.getMonth() + 1}-${input.getDate()}`;
}